
import React, { useEffect } from "react";
import "../LaundryPrice/LaundryPrice.css";
import FaqAccordion from "./FqsAccordion/FaqAccordion";
import { Container, Row, Col, Navbar, Nav, Button, Card, Badge, ListGroup } from 'react-bootstrap';

import AOS from "aos";
import "aos/dist/aos.css";
const fqsqustions = "/images/home/5asec-FAQs.webp";
export default function Faqloundryqustions() {
  useEffect(() => {
    AOS.init({
      duration: 1200,
      easing: "ease-in-out",
      once: true,
      offset: 80,
    });
  }, []);
  return (
    <div>

      <section className="hero-section-wash-fold mt-5">
        <div className="hero-overlay-wash-fold mt-5">
          <Container fluid="xl" className="py-5 mt-4 h-100">
            <Row className="align-items-center justify-content-center text-center h-100 mt-5">
              <Col lg={8}>
                <h2 className="mt-4" style={{ color: "white", fontWeight: "bold" }}>FAQs</h2>
                <h1 className="hero-title mb-4">
                  How can we help  <br />
                </h1>

                <p className="description" style={{ color: "white", textAlign: "center" }}>
                  Here are some of the most asked questions by our customers.<br />
                  If you cannot find answers to the questions you have, please contact <br />
                  our team and we will be happy to assist.
                </p>

                <div className="d-flex justify-content-center flex-wrap gap-3 mt-4">
                  <button className="suhedule-btn-dark"
                    onClick={() =>
                      window.open(
                        "https://api.whatsapp.com/send?phone=971545718455&text=Hi,%20I%20would%20like%20to%20book%20a%20laundry%20pickup.",
                        "_blank"
                      )
                    }>
                    📞 Order via Phone
                  </button>

                  <button className="view-prices-list"
                    onClick={() =>
                      window.open(
                        "https://api.whatsapp.com/send?phone=971545718455&text=Hi,%20I%20would%20like%20to%20book%20a%20laundry%20pickup.",
                        "_blank"
                      )
                    }>
                    💬 Order via WhatsApp
                  </button>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </section>

      <FaqAccordion />

    </div>
  );
}
